import React, { Suspense } from 'react';
import { useTranslations } from '@core/js/hooks/i18n';
import { ManagedPopup } from '@core/js/components/common/Popup';
import { useCombinedOnClose } from '@core/js/components/common/PopupManager';
import { getAcceptDeclineButtons } from '@core/js/components/common/popups/ConfirmationPopup';
import { TermsConditions } from '@core/js/components/main/TermsConditions';

import * as Types from '@core/js/components/popups/TermsConditionsConfirmationPopup/types';

import style from '@core/js/components/popups/TermsConditionsConfirmationPopup/TermsConditionsConfirmationPopup.scss';

export const TermsConditionsConfirmationPopup: React.FC<Types.ITermsConditionsConfirmationPopupProps> = ({
    id,
    onAccept,
    onDecline,
    tcVersion
}) => {
    const onAcceptClick = useCombinedOnClose(onAccept, id);
    const onDeclineClick = useCombinedOnClose(onDecline, id);
    const translate = useTranslations('playtech.mobile.system.popup.TC.');

    const buttons = getAcceptDeclineButtons({
        onAcceptClick,
        onDeclineClick
    });

    return (
        <ManagedPopup
            id={id}
            isModal
            buttons={buttons}
            title={translate('title')}
            classNames={{ inner: style.innerContent }}
            className={'terms-conditions__Popup'} // @theme
            layerClassNames={{ layout: style.layout }}
        >
            <Suspense fallback="">
                <TermsConditions tcVersion={tcVersion} />
            </Suspense>
        </ManagedPopup>
    );
};
